var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.custom)?_c('svgicon',{class:("material-icons icon--" + _vm.icon),attrs:{"name":_vm.icon}}):_c('i',_vm._g({staticClass:"material-icons"},_vm.$listeners),[_vm._v(_vm._s(_vm.icon))])}
var staticRenderFns = []

export { render, staticRenderFns }